import React, { useMemo } from 'react'
import { SEARCH_PARAMS, getSearchParams } from 'components/utils/url'
import { useNewTranslation } from 'hooks'
import RectangleButton from 'particles/Button/RectangleButton'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { selectIsMultiSelectMode, selectCheckCanReviewSubmissionByStep, VERIFY_TAB_TYPE } from 'state/review'
import { StepState } from 'state/tasks'
import { SubmissionActionWrapper } from './styles'

type ViewDetailButtonProps = {
    submissionProgressUuid: string
    step: StepState
}

const ViewDetailButton = ({ submissionProgressUuid, step }: ViewDetailButtonProps) => {
    const [newT] = useNewTranslation()
    const isMultiSelectMode = useSelector(selectIsMultiSelectMode)
    const checkCanReviewSubmissionByStep = useSelector(selectCheckCanReviewSubmissionByStep)
    const canRejectOrVerify = useMemo(
        () => checkCanReviewSubmissionByStep(step.type),
        [checkCanReviewSubmissionByStep, step.type],
    )
    const history = useHistory()

    const handleViewSubmission = () => {
        const searchParams = getSearchParams({
            add: [
                { key: SEARCH_PARAMS.verifyTab, value: VERIFY_TAB_TYPE.DISCUSSION },
                { key: SEARCH_PARAMS.reviewId, value: submissionProgressUuid },
            ],
        })
        history.push(searchParams)
    }

    return !canRejectOrVerify ? (
        <SubmissionActionWrapper>
            <RectangleButton
                form="filled"
                size="m"
                label={newT('button.viewDetail', 'View Details')}
                onClick={handleViewSubmission}
                isDisabled={isMultiSelectMode}
                className="width-full"
            />
        </SubmissionActionWrapper>
    ) : null
}

export default ViewDetailButton
